var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxEnable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10817_42467)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#2A85FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8046 4.19526C14.0649 4.45561 14.0649 4.87772 13.8046 5.13807L8.08072 10.8619C7.29967 11.643 6.03334 11.643 5.25229 10.8619L2.86177 8.4714C2.60142 8.21106 2.60142 7.78894 2.86177 7.5286C3.12212 7.26825 3.54423 7.26825 3.80458 7.5286L6.1951 9.91912C6.45545 10.1795 6.87756 10.1795 7.13791 9.91912L12.8618 4.19526C13.1221 3.93491 13.5442 3.93491 13.8046 4.19526Z",
    fill: "#FCFCFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10817_42467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxEnable);
export default __webpack_public_path__ + "static/media/Checkbox_Enable.4eb65f25aae355bb3457077428bf6a31.svg";
export { ForwardRef as ReactComponent };